import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import useIsHydrated from '../Hooks/useIsHydrated'
import { renderTextWithLink } from '../Utilities/TextWithLink'
import { showXSellDisclosure, isCreditKarmaPage } from '../../helpers/lightbox'

function CustomHeroDisclaimer({ disclaimer }) {
  const [xSellDisclosure, setXSellDisclosure] = useState(false)
  const [creditKarmaPage, setCreditKarmaPage] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined' || !isCreditKarmaPage()) return
    setCreditKarmaPage(true)
    if (showXSellDisclosure()) {
      setXSellDisclosure(true)
    }
  }, [])
  const isHydrated = useIsHydrated()
  // Returns null on first render, so the client and server match
  if (!isHydrated) return null

  if (disclaimer?.disclaimer && creditKarmaPage && xSellDisclosure) {
    return (
      <p className="disclaimer xsell">
        {renderTextWithLink(disclaimer.disclaimer, 'flat-link--white')}
      </p>
    )
  }
  if (disclaimer?.disclaimer && creditKarmaPage && !xSellDisclosure) {
    return (
      <p className="disclaimer hidden">
        {renderTextWithLink(disclaimer.disclaimer, 'flat-link--white')}
      </p>
    )
  }
  if (disclaimer?.disclaimer) {
    return (
      <p className="disclaimer">{renderTextWithLink(disclaimer.disclaimer, 'flat-link--white')}</p>
    )
  }
  return null
}

CustomHeroDisclaimer.defaultProps = {
  disclaimer: { disclaimer: '' }
}

CustomHeroDisclaimer.propTypes = {
  disclaimer: PropTypes.object
}

export default CustomHeroDisclaimer
